import { sortBy } from 'lodash';
import { format } from 'date-fns';
import { fetchContract, fetchContractSubscription } from '../../api/paymentApi';

const GET_CONTRACT = 'efes/recurringPayment/GET_CONTRACT';
const GET_CONTRACT_SUCCESS = 'efes/recurringPayment/GET_CONTRACT_SUCCESS';
const GET_CONTRACT_FAIL = 'efes/recurringPayment/GET_CONTRACT_FAIL';
const UPDATE_CONTRACT = 'efes/recurringPayment/UPDATE_CONTRACT';
const SET_CONTRACT = 'efes/recurringPayment/SET_CONTRACT';
const CLEAR_CONTRACT = 'efes/recurringPayment/CLEAR_CONTRACT';

export const getTotalAndBalance = (tableRows) => {
  if (!tableRows) {
    return { total: 0, selectedToPay: 0 };
  }
  const notDisabledPayments = tableRows.filter((item) => !item.isDisabled);
  const total = notDisabledPayments.reduce((acc, curr) => acc + curr.maxPayable, 0);
  const lastCheked = tableRows.find((el) => el.isLastChecked);
  let selectedToPay = 0;
  notDisabledPayments.some(({ rowId, maxPayable, payable }) => {
    if (rowId > lastCheked.rowId) {
      return true;
    }
    if (rowId < lastCheked.rowId) {
      selectedToPay += maxPayable;
    } else {
      selectedToPay += payable;
    }
    return false;
  });
  return { total, selectedToPay };
};

const prepareData = (data) => {
  if (data.isError === 1) {
    return data;
  }

  const {
    payment,
    insuredEmail,
    insuredFirstName,
    insuredLastName,
    insuredMobilePhone,
  } = data.result;

  const sortedPayments = sortBy(payment, 'date');

  const firstNotPaidRow = sortedPayments.find((el) => el.balance !== '0.00');
  if (!firstNotPaidRow) {
    return { ...data, isFullyPaid: true };
  }

  const signer = {
    email: insuredEmail,
    firstName: insuredFirstName,
    lastName: insuredLastName,
    mobilePhone: insuredMobilePhone,
  };

  const tableRows = sortedPayments.map((p, i) => {
    const { amount, balance, date } = p;

    const formatedBalance = parseInt(balance, 10);

    const isDisabled = formatedBalance === 0;

    const formatedAmount = parseInt(amount, 10);

    const formatedDate = format(new Date(date), 'dd/MM/yyyy');

    const isAlwaysChecked = date === firstNotPaidRow.date;

    const status = isDisabled ? 'recurrPayment.status.paid' : 'recurrPayment.status.notPaid';

    return {
      rowId: i,
      isDisabled,
      isAlwaysChecked: isDisabled || isAlwaysChecked,
      isChecked: isDisabled || isAlwaysChecked,
      isLastChecked: isAlwaysChecked,
      date: formatedDate,
      amount: formatedAmount,
      payable: formatedBalance, // user can change payable
      maxPayable: formatedBalance,
      status,
    };
  });

  return { ...data, tableRows, signer, totalAndBalance: getTotalAndBalance(tableRows) };
};

const initialState = {
  contract: {
    policyNumber: '',
    totalAndBalance: {},
    signer: {},
  },
  attachedCard: {},
  isLoading: false,
  error: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_CONTRACT:
      return {
        ...state,
        isLoading: true,
      };
    case GET_CONTRACT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        contract: prepareData(action.result),
        attachedCard: action.result.attachedCard,
        error: null,
      };
    case GET_CONTRACT_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.error,
        contract: {
          policyNumber: '',
          totalAndBalance: {},
          signer: {},
        },
        attachedCard: {},
      };
    case SET_CONTRACT:
      return {
        ...state,
        contract: action.contract,
      };
    case UPDATE_CONTRACT:
      return {
        ...state,
        contract: action.contract,
      };
    case CLEAR_CONTRACT:
      return {
        ...state,
        contract: {
          policyNumber: '',
          totalAndBalance: {},
          signer: {},
        },
      };
    default:
      return state;
  }
}

export function getContract(data) {
  return {
    actions: [
      { type: GET_CONTRACT },
      { type: GET_CONTRACT_SUCCESS },
      { type: GET_CONTRACT_FAIL, showError: true },
    ],
    promise: fetchContract(data),
  };
}

export function getContractSubscription(data) {
  return {
    actions: [
      { type: GET_CONTRACT },
      { type: GET_CONTRACT_SUCCESS },
      { type: GET_CONTRACT_FAIL, showError: true },
    ],
    promise: fetchContractSubscription(data),
  };
}

export const setContract = (contract) => ({
  type: SET_CONTRACT,
  contract,
});

export const updateContract = (contract) => ({
  type: UPDATE_CONTRACT,
  contract: {
    ...contract,
    totalAndBalance: getTotalAndBalance(contract.tableRows),
  },
});

export const clearContract = () => ({
  type: CLEAR_CONTRACT,
});
